module.exports = __webpack_public_path__ + "static/osaka-1-da1e193d66100187ded8845afac747ce.png";